export type MediaType = "movie" | "tv";

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  year: number;
  genres: string[];
  rating: number;
  region: string;
  duration: string;
  director: string;
  cast: string[];
  synopsis: string;
  story: string;
  poster: string;
  backdrop: string;
  updatedAt: string;
}

export const movieGenres = [
  "全部",
  "动作",
  "喜剧",
  "剧情",
  "科幻",
  "悬疑",
  "爱情",
  "古装",
  "犯罪",
  "奇幻",
  "冒险",
  "惊悚",
];

export const tvGenres = [
  "全部",
  "都市",
  "古装",
  "悬疑",
  "科幻",
  "武侠",
  "家庭",
  "历史",
  "青春",
  "医疗",
  "年代",
  "刑侦",
];

export const yearOptions = [
  "全部",
  "2025",
  "2024",
  "2023",
  "2022",
  "2021",
  "2020",
];

export const mediaList: MediaItem[] = [
  {
    id: "1",
    title: "长夜追凶",
    type: "movie",
    year: 2025,
    genres: ["犯罪", "悬疑"],
    rating: 9.1,
    region: "中国大陆",
    duration: "128分钟",
    director: "陈默然",
    cast: ["周衍", "林悦然", "高鹏"],
    synopsis: "一桩尘封十二年的悬案重新浮出水面，退休警探被迫重返案发现场追寻真相。",
    story:
      "雨夜的城市像一张被浸透的旧报纸。退休警探周衍被一通匿名电话叫回警局，十二年前那桩早已结案的少女失踪案，因一份新出现的物证被重新立案。随着调查深入，他发现自己当年的判断并非偶然失误，而是被人精心引导。真相藏在这座城市最灯火通明的地方，也藏在他最不愿回想的记忆里。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%2C%20rainy%20night%20city%20street%2C%20lone%20detective%20silhouette%2C%20deep%20dark%20blue%20tones%20with%20orange%20street%20light%20glow%2C%20dramatic%20moody%20lighting%2C%20artistic%20minimal%20composition&width=480&height=720&seq=tl-movie-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20scene%2C%20rainy%20neon%20city%20night%20street%2C%20deep%20dark%20blue%20atmosphere%20with%20orange%20light%20reflections%2C%20moody%20wide%20shot%2C%20film%20still%20aesthetic&width=1600&height=900&seq=tl-bk-01&orientation=landscape",
    updatedAt: "2025-06-18",
  },
  {
    id: "2",
    title: "城市之光",
    type: "movie",
    year: 2025,
    genres: ["剧情", "都市"],
    rating: 8.4,
    region: "中国大陆",
    duration: "116分钟",
    director: "苏婉",
    cast: ["李承宇", "许安然", "罗晓"],
    synopsis: "深夜便利店的店员用一盏灯，温暖了无数个迷失在城市里的陌生人。",
    story:
      "在一座昼夜不眠的超级城市里，24小时便利店的店员林知夏习惯了观察每一个深夜进店的客人。加班到崩溃的白领、和为梦想打拼的街头歌手、失去方向的中年男人……她用一个微笑、一份热食，悄悄参与着他们的人生。直到某天，一道突如其来的消息让她不得不重新思考自己留在城市的意义。",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20urban%20drama%20movie%20poster%2C%20convenience%20store%20glow%20at%20night%2C%20young%20woman%20standing%20in%20soft%20light%2C%20dark%20blue%20city%20background%20with%20orange%20warm%20lamp%2C%20cinematic%20emotional%20tone%2C%20minimal%20artistic%20layout&width=480&height=720&seq=tl-movie-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cozy%20city%20night%20street%20with%20glowing%20storefront%2C%20dark%20blue%20evening%20tones%20and%20warm%20orange%20lamplight%2C%20soft%20bokeh%2C%20cinematic%20urban%20drama%20film%20still&width=1600&height=900&seq=tl-bk-02&orientation=landscape",
    updatedAt: "2025-06-15",
  },
  {
    id: "3",
    title: "星际方舟",
    type: "movie",
    year: 2025,
    genres: ["科幻", "冒险"],
    rating: 8.9,
    region: "中国大陆 / 美国",
    duration: "142分钟",
    director: "凯文·罗",
    cast: ["蒋启明", "艾拉·斯通", "陈子豪"],
    synopsis: "当地球资源枯竭，一支舰队带着人类最后的希望驶向未知的深空。",
    story:
      "公元2187年，地表已不再适宜生存。人类建造了十艘星际方舟，分散驶向宇宙深处的候选星球。工程师蒋启明所在的第七方舟在穿越星际尘埃云时遭遇系统崩溃，船员们被迫进入休眠与苏醒的循环。当方舟偏离航线，一个关于“目的地是否真实存在”的秘密逐渐浮出水面。",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20movie%20poster%2C%20spaceship%20fleet%20before%20giant%20planet%2C%20deep%20navy%20space%20with%20orange%20engine%20glow%2C%20cinematic%20scale%2C%20minimal%20futuristic%20composition&width=480&height=720&seq=tl-movie-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20space%20scene%20with%20starship%20near%20glowing%20planet%2C%20deep%20navy%20blue%20nebula%20and%20warm%20orange%20thruster%20light%2C%20cinematic%20wide%20shot%20film%20still&width=1600&height=900&seq=tl-bk-03&orientation=landscape",
    updatedAt: "2025-06-12",
  },
  {
    id: "4",
    title: "山海拾遗",
    type: "movie",
    year: 2024,
    genres: ["奇幻", "古装"],
    rating: 8.2,
    region: "中国大陆",
    duration: "134分钟",
    director: "顾云深",
    cast: ["白鹿鸣", "沈清欢", "顾北辰"],
    synopsis: "古籍修复师意外翻开一部残卷，被卷入山海之间的神话世界。",
    story:
      "年轻的古籍修复师白鹿鸣在整理一批流散文物时，发现了一本没有任何记录的残卷。当她触碰到残卷的瞬间，城市消失了，取而代之的是云海翻涌、异兽横行的大荒之境。为了回到现实，她必须收集散落各地的山海残页，而每一页背后，都封存着一段被遗忘的古老传说。",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20fantasy%20movie%20poster%2C%20misty%20mountains%20and%20mythical%20beast%2C%20dark%20blue%20clouds%20with%20orange%20sunrise%20glow%2C%20elegant%20artistic%20ink%20style%2C%20cinematic%20composition&width=480&height=720&seq=tl-movie-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=mystical%20ancient%20chinese%20mountains%20with%20floating%20clouds%2C%20dark%20blue%20tones%20and%20warm%20orange%20sunrise%20light%2C%20epic%20fantasy%20ink%20painting%20film%20still&width=1600&height=900&seq=tl-bk-04&orientation=landscape",
    updatedAt: "2024-12-28",
  },
  {
    id: "5",
    title: "无声告白",
    type: "movie",
    year: 2024,
    genres: ["悬疑", "剧情"],
    rating: 8.7,
    region: "中国大陆",
    duration: "121分钟",
    director: "郑一凡",
    cast: ["何静姝", "马天宇", "刘思远"],
    synopsis: "一位听障心理医生，用无声的观察解开了一桩连环失踪案的关键谜题。",
    story:
      "听障心理医生何静姝擅长通过微表情与手语解读人心。她的一位患者在一场看似普通的车祸后突然失踪，警方判定为意外。然而她注意到一连串被忽视的细节，逐渐将几起毫不相关的失踪案串联起来。当她越接近真相，越发现那个沉默的凶手，可能就在她每天都会见到的人之中。",
    poster:
      "https://readdy.ai/api/search-image?query=psychological%20mystery%20movie%20poster%2C%20silent%20portrait%20of%20woman%20half%20in%20shadow%2C%20dark%20blue%20background%20with%20orange%20rim%20light%2C%20minimal%20suspenseful%20cinematic%20art&width=480&height=720&seq=tl-movie-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dark%20psychological%20thriller%20corridor%20with%20soft%20orange%20light%20beam%2C%20deep%20blue%20shadows%2C%20moody%20cinematic%20film%20still%20wide%20shot&width=1600&height=900&seq=tl-bk-05&orientation=landscape",
    updatedAt: "2024-11-30",
  },
  {
    id: "6",
    title: "逆风奔跑",
    type: "movie",
    year: 2024,
    genres: ["剧情", "冒险"],
    rating: 8.0,
    region: "中国大陆",
    duration: "112分钟",
    director: "田大力",
    cast: ["赵野", "孙可", "吴晴"],
    synopsis: "双腿受伤的短跑少年，在高原训练基地重新找回奔跑的意义。",
    story:
      "曾经的天才短跑少年赵野因一次严重伤病几乎告别赛场。他独自来到海拔三千米的高原训练基地，遇到了同样在人生低谷徘徊的教练和队友。在稀薄的空气和漫长的无人问津中，他们彼此支撑，重新定义了“胜利”二字，也找回了奔跑本身的快乐。",
    poster:
      "https://readdy.ai/api/search-image?query=inspirational%20sports%20drama%20movie%20poster%2C%20young%20runner%20on%20mountain%20road%20at%20dawn%2C%20deep%20blue%20sky%20with%20orange%20sunrise%2C%20cinematic%20motivational%20tone%2C%20minimal%20artistic%20layout&width=480&height=720&seq=tl-movie-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=lone%20runner%20on%20high%20plateau%20road%20at%20sunrise%2C%20deep%20blue%20morning%20sky%20with%20warm%20orange%20sunlight%2C%20cinematic%20wide%20film%20still&width=1600&height=900&seq=tl-bk-06&orientation=landscape",
    updatedAt: "2024-10-20",
  },
  {
    id: "7",
    title: "长安月下",
    type: "movie",
    year: 2023,
    genres: ["古装", "爱情"],
    rating: 7.9,
    region: "中国大陆",
    duration: "126分钟",
    director: "柳青禾",
    cast: ["萧云舟", "苏梨", "洛书"],
    synopsis: "盛世长安的灯火之下，一场关于家国与深情的抉择悄然上演。",
    story:
      "上元灯节的长安城灯火如昼，画师萧云舟偶遇微服出行的郡主苏梨。两人因一幅未完成的画相识，从此卷入朝堂与江湖的双重漩涡。当和亲的诏书下达，他们不得不面对一个难题：是守护心中所爱，还是肩负家国天下。",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20romance%20movie%20poster%2C%20couple%20under%20lantern%20moonlight%2C%20deep%20blue%20night%20sky%20with%20warm%20orange%20lantern%20glow%2C%20elegant%20artistic%20cinematic%20composition&width=480&height=720&seq=tl-movie-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20lantern%20festival%20at%20night%2C%20deep%20blue%20sky%20with%20warm%20orange%20lanterns%20reflected%20on%20water%2C%20cinematic%20wide%20film%20still&width=1600&height=900&seq=tl-bk-07&orientation=landscape",
    updatedAt: "2023-12-10",
  },
  {
    id: "8",
    title: "深海回响",
    type: "movie",
    year: 2023,
    genres: ["科幻", "惊悚"],
    rating: 8.3,
    region: "中国大陆",
    duration: "118分钟",
    director: "雷鸣",
    cast: ["程深", "叶澜", "周越"],
    synopsis: "深海科研站收到一段来自万米海沟的神秘信号，打破了一切平静。",
    story:
      "在马里亚纳海沟深处的科研站，一支国际科考队探测到一段有规律的未知信号。随着设备深入海沟，队员们的听觉和记忆开始出现异常。海洋生物学家程深发现，那段信号似乎能唤醒每个人内心最深的恐惧。当逃生的潜水艇只剩一个座位，真相与人性一同浮出水面。",
    poster:
      "https://readdy.ai/api/search-image?query=deep%20sea%20sci-fi%20thriller%20movie%20poster%2C%20submarine%20in%20dark%20ocean%20trench%2C%20deep%20blue%20abyss%20with%20orange%20sonar%20glow%2C%20cinematic%20tense%20minimal%20art&width=480&height=720&seq=tl-movie-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20with%20submersible%20lights%2C%20pitch%20dark%20blue%20water%20with%20warm%20orange%20beam%2C%20cinematic%20underwater%20film%20still&width=1600&height=900&seq=tl-bk-08&orientation=landscape",
    updatedAt: "2023-09-22",
  },
  {
    id: "9",
    title: "荒漠迷踪",
    type: "movie",
    year: 2023,
    genres: ["冒险", "悬疑"],
    rating: 7.6,
    region: "中国大陆",
    duration: "124分钟",
    director: "胡沙",
    cast: ["聂风", "白露", "沙舟"],
    synopsis: "一支探险队在无人区寻找失落古城，却走进了自己布下的迷宫。",
    story:
      "为了寻找地图上不曾标注的古城遗址，考古探险队深入西北无人区。沙暴、断水、迷失方向，他们逐渐意识到手中的地图被人动过手脚。当队员一个接一个离奇失踪，领队聂风必须在信仰与生存之间做出选择，而那片荒漠，似乎正注视着他们每一个人。",
    poster:
      "https://readdy.ai/api/search-image?query=desert%20adventure%20movie%20poster%2C%20lone%20explorer%20on%20sand%20dunes%2C%20deep%20blue%20dusk%20sky%20with%20warm%20orange%20horizon%20glow%2C%20cinematic%20epic%20minimal%20composition&width=480&height=720&seq=tl-movie-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=vast%20desert%20dunes%20at%20dusk%20with%20tiny%20caravan%20silhouette%2C%20deep%20blue%20sky%20and%20warm%20orange%20horizon%2C%20cinematic%20wide%20film%20still&width=1600&height=900&seq=tl-bk-09&orientation=landscape",
    updatedAt: "2023-08-05",
  },
  {
    id: "10",
    title: "你好，旧时光",
    type: "movie",
    year: 2022,
    genres: ["爱情", "剧情"],
    rating: 8.5,
    region: "中国大陆",
    duration: "108分钟",
    director: "沈知夏",
    cast: ["林南", "周晚", "陈嘉"],
    synopsis: "一封迟到十年的信，让两个早已走散的人重新相遇。",
    story:
      "整理母亲老屋时，林南在书柜深处发现了一封自己从未寄出的信，收信人是大学时代最好的朋友周晚。十年间，两人各自走过不同的人生。带着这封信，林南踏上了寻找周晚的旅程，也在途中重新翻阅了那段明亮又遗憾的旧时光。",
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%20romance%20movie%20poster%2C%20old%20letter%20and%20window%20with%20soft%20light%2C%20deep%20blue%20shadows%20with%20warm%20orange%20afternoon%20glow%2C%20cinematic%20tender%20minimal%20art&width=480&height=720&seq=tl-movie-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=quiet%20old%20room%20with%20sunlit%20window%20and%20dust%20particles%2C%20deep%20blue%20shade%20with%20warm%20orange%20light%2C%20cinematic%20nostalgic%20film%20still&width=1600&height=900&seq=tl-bk-10&orientation=landscape",
    updatedAt: "2022-11-18",
  },
  {
    id: "11",
    title: "暗夜信使",
    type: "movie",
    year: 2022,
    genres: ["动作", "犯罪"],
    rating: 7.8,
    region: "中国大陆 / 香港",
    duration: "119分钟",
    director: "陈家豪",
    cast: ["高天", "莫安娜", "郑凯"],
    synopsis: "一名游走在黑白边缘的快递员，意外成了城市最大的秘密的信使。",
    story:
      "白天是普通快递员的阿天，夜里替一个神秘组织运送“包裹”。当他无意间打开一个送错的包裹，看到里面的东西后，他成了所有人追杀的目标。警方、黑帮、旧日兄弟纷纷找上门，他必须在黎明前，把这个秘密送到唯一能揭开真相的人手里。",
    poster:
      "https://readdy.ai/api/search-image?query=action%20crime%20movie%20poster%2C%20courier%20on%20motorcycle%20in%20neon%20alley%2C%20deep%20blue%20night%20with%20orange%20neon%20signs%2C%20cinematic%20high%20contrast%20minimal%20art&width=480&height=720&seq=tl-movie-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=motorcycle%20speeding%20through%20neon%20city%20alley%20at%20night%2C%20deep%20blue%20tone%20with%20orange%20neon%20light%20streaks%2C%20cinematic%20action%20film%20still&width=1600&height=900&seq=tl-bk-11&orientation=landscape",
    updatedAt: "2022-07-30",
  },
  {
    id: "12",
    title: "半城烟雨",
    type: "movie",
    year: 2021,
    genres: ["剧情", "爱情"],
    rating: 8.1,
    region: "中国大陆",
    duration: "110分钟",
    director: "江南",
    cast: ["温言", "沈墨", "许清"],
    synopsis: "江南小城的雨季里，两代人的故事在一间老书店里缓缓展开。",
    story:
      "江南水乡的雨季绵长而安静。老书店的守店人温言迎来了一位特殊的客人——一个想为过世祖母寻找一本绝版书的年轻人。在翻找旧书的过程中，一段跨越两代人的往事被重新拼凑起来，也治愈了彼此心中难以言说的遗憾。",
    poster:
      "https://readdy.ai/api/search-image?query=artistic%20literary%20film%20poster%2C%20rainy%20jiangnan%20water%20town%20with%20old%20bookstore%2C%20muted%20deep%20blue%20with%20warm%20orange%20lamp%2C%20cinematic%20elegant%20minimal%20art&width=480&height=720&seq=tl-movie-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rainy%20jiangnan%20water%20town%20with%20stone%20bridge%20and%20lanterns%2C%20muted%20deep%20blue%20ton%20with%20warm%20orange%20glow%2C%20cinematic%20literary%20film%20still&width=1600&height=900&seq=tl-bk-12&orientation=landscape",
    updatedAt: "2021-10-02",
  },
  {
    id: "13",
    title: "江湖夜雨十年灯",
    type: "tv",
    year: 2025,
    genres: ["武侠", "古装"],
    rating: 9.0,
    region: "中国大陆",
    duration: "全38集",
    director: "萧墨白",
    cast: ["陆行舟", "叶疏影", "江晚"],
    synopsis: "一封旧信、一柄残剑，牵出江湖十年的恩怨与一场未了的情。",
    story:
      "十年前，一场大火烧尽武林盟的荣光，也让三位挚友分道扬镳。十年后，年轻的剑客陆行舟带着一柄残剑重回江湖，寻找当年事件的真相。他遇见隐居山野的旧友，也重逢了那个不告而别的人。随着线索层层剥开，所谓正邪的界限变得模糊，一场席卷江湖的风暴正悄然逼近。",
    poster:
      "https://readdy.ai/api/search-image?query=chinese%20wuxia%20drama%20poster%2C%20swordsman%20with%20broken%20sword%20under%20rain%2C%20deep%20blue%20storm%20sky%20with%20orange%20lantern%20glow%2C%20cinematic%20epic%20ink%20art&width=480&height=720&seq=tl-tv-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=chinese%20wuxia%20scene%20swordsman%20on%20cliff%20in%20rain%2C%20deep%20blue%20storm%20with%20warm%20orange%20lantern%20light%2C%20cinematic%20epic%20film%20still&width=1600&height=900&seq=tl-bk-13&orientation=landscape",
    updatedAt: "2025-06-20",
  },
  {
    id: "14",
    title: "都市浮生记",
    type: "tv",
    year: 2025,
    genres: ["都市", "家庭"],
    rating: 8.4,
    region: "中国大陆",
    duration: "全42集",
    director: "林晓",
    cast: ["方致远", "许知微", "王丽娜"],
    synopsis: "一栋老式居民楼里，三个普通家庭在都市变迁中彼此交织。",
    story:
      "在城市更新改造的浪潮下，一栋即将拆迁的老居民楼里住着三户人家：坚持不搬的老裁缝、努力攒钱买房的小夫妻、刚毕业合租的年轻人。他们的生活因一场意外的电梯故障而交织在一起，在琐碎的日常与时代的洪流中，书写着属于普通人的悲欢离合。",
    poster:
      "https://readdy.ai/api/search-image?query=urban%20family%20drama%20poster%2C%20old%20apartment%20building%20windows%20at%20dusk%2C%20deep%20blue%20evening%20with%20warm%20orange%20room%20lights%2C%20cinematic%20realistic%20tone&width=480&height=720&seq=tl-tv-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=old%20city%20apartment%20building%20at%20dusk%2C%20deep%20blue%20sky%20with%20warm%20orange%20window%20lights%2C%20cinematic%20urban%20life%20film%20still&width=1600&height=900&seq=tl-bk-14&orientation=landscape",
    updatedAt: "2025-06-16",
  },
  {
    id: "15",
    title: "星轨边缘",
    type: "tv",
    year: 2025,
    genres: ["科幻", "悬疑"],
    rating: 8.8,
    region: "中国大陆",
    duration: "全24集",
    director: "顾天择",
    cast: ["江寒", "苏离", "罗宇"],
    synopsis: "空间站研究员发现，自己每天醒来都在同一段记忆里循环。",
    story:
      "在环绕地球运行的“星轨”空间站上，研究员江寒某天醒来后，发现一切似乎都和昨天一模一样。起初他以为只是失眠导致的错觉，直到他注意到舱壁上一道每天都会重新出现的划痕。为了弄清真相，他开始记录、推断、对抗，最终发现这座空间站隐藏着一个关乎全人类记忆的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=sci-fi%20mystery%20series%20poster%2C%20astronaut%20reflection%20in%20space%20station%20window%2C%20deep%20blue%20space%20with%20orange%20warning%20light%2C%20cinematic%20minimal%20art&width=480&height=720&seq=tl-tv-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=space%20station%20interior%20with%20earth%20view%20through%20window%2C%20deep%20blue%20tones%20with%20warm%20orange%20control%20lights%2C%20cinematic%20sci-fi%20film%20still&width=1600&height=900&seq=tl-bk-15&orientation=landscape",
    updatedAt: "2025-06-10",
  },
  {
    id: "16",
    title: "医者仁心",
    type: "tv",
    year: 2024,
    genres: ["医疗", "都市"],
    rating: 8.6,
    region: "中国大陆",
    duration: "全40集",
    director: "韩清",
    cast: ["沈立德", "安琪", "陈阳"],
    synopsis: "急诊科的一夜又一夜，见证着生死、抉择与不曾熄灭的善意。",
    story:
      "急诊科主任沈立德从医三十年，见过太多来不及说再见的离别。一名年轻住院医师安琪的到来，为科室带来新的活力，也带来了理念的碰撞。在一场突发公共卫生事件中，整个急诊科面临前所未有的考验，而他们用行动回答了“何为医者仁心”。",
    poster:
      "https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%2C%20doctor%20in%20dim%20emergency%20room%2C%20deep%20blue%20shadows%20with%20warm%20orange%20surgical%20light%2C%20cinematic%20emotional%20tone&width=480&height=720&seq=tl-tv-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=hospital%20emergency%20corridor%20at%20night%20with%20soft%20lights%2C%20deep%20blue%20tones%20with%20warm%20orange%20accent%2C%20cinematic%20medical%20drama%20film%20still&width=1600&height=900&seq=tl-bk-16&orientation=landscape",
    updatedAt: "2024-12-22",
  },
  {
    id: "17",
    title: "千门八将",
    type: "tv",
    year: 2024,
    genres: ["悬疑", "刑侦"],
    rating: 8.5,
    region: "中国大陆",
    duration: "全32集",
    director: "魏铭",
    cast: ["林骁", "苏婉清", "秦戈"],
    synopsis: "一支临时组建的专案组，面对的是一个横跨八城的诈骗集团。",
    story:
      "一桩看似普通的电信诈骗案，牵扯出一个组织严密、分工明确的犯罪网络。刑侦队长林骁被迫与一位擅长“以骗制骗”的前诈骗高手合作，组建临时专案组。团队跨越八座城市追踪线索，每一次收网都像揭开一层伪装，而幕后的“千门之首”，可能比他们想象中更近。",
    poster:
      "https://readdy.ai/api/search-image?query=crime%20investigation%20series%20poster%2C%20detective%20board%20with%20photos%20and%20red%20strings%2C%20deep%20blue%20tone%20with%20warm%20orange%20desk%20lamp%2C%20cinematic%20tense%20minimal%20art&width=480&height=720&seq=tl-tv-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dark%20investigation%20room%20with%20evidence%20board%20and%20soft%20light%2C%20deep%20blue%20tones%20with%20warm%20orange%20lamp%2C%20cinematic%20crime%20film%20still&width=1600&height=900&seq=tl-bk-17&orientation=landscape",
    updatedAt: "2024-11-15",
  },
  {
    id: "18",
    title: "春暖花开时",
    type: "tv",
    year: 2024,
    genres: ["家庭", "都市"],
    rating: 8.0,
    region: "中国大陆",
    duration: "全36集",
    director: "周暖",
    cast: ["李桂芬", "张明远", "苏小满"],
    synopsis: "返乡创业的年轻人，和留守小镇的长辈们，一起等来了属于他们的春天。",
    story:
      "在外打拼多年后，苏小满带着一身的疲惫和一点点积蓄回到家乡。面对不理解的长辈、荒废的老宅和正在消失的手艺，她决定留下来试一试。在一次次碰壁与扶持中，小镇慢慢有了新的模样，而她也终于明白，家不只是一个地方，更是一种被等待的感觉。",
    poster:
      "https://readdy.ai/api/search-image?query=heartwarming%20family%20series%20poster%2C%20young%20woman%20in%20blooming%20spring%20field%2C%20deep%20blue%20sky%20with%20warm%20orange%20sunrise%2C%20cinematic%20hopeful%20minimal%20art&width=480&height=720&seq=tl-tv-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=peaceful%20countryside%20village%20in%20spring%20bloom%2C%20deep%20blue%20sky%20with%20warm%20orange%20sunrise%20light%2C%20cinematic%20heartwarming%20film%20still&width=1600&height=900&seq=tl-bk-18&orientation=landscape",
    updatedAt: "2024-10-08",
  },
  {
    id: "19",
    title: "权谋天下",
    type: "tv",
    year: 2023,
    genres: ["历史", "古装"],
    rating: 8.9,
    region: "中国大陆",
    duration: "全50集",
    director: "王守正",
    cast: ["秦昭", "萧景琰", "沈砚"],
    synopsis: "朝堂之上风起云涌，一位年轻谋士在权力漩涡中步步为营。",
    story:
      "乱世将定未定，年轻的谋士沈砚以一介布衣之身走入庙堂。他辅佐的新君仁厚却优柔，朝中权臣虎视眈眈，边关战事一触即发。在一次次惊心动魄的博弈中，沈砚必须权衡忠诚与野心，也要守住自己最初的那份赤子之心。江山如棋局，落子无悔。",
    poster:
      "https://readdy.ai/api/search-image?query=chinese%20historical%20drama%20poster%2C%20scholar%20in%20court%20robes%20before%20palace%2C%20deep%20blue%20imperial%20tones%20with%20warm%20orange%20torch%20light%2C%20cinematic%20epic%20composition&width=480&height=720&seq=tl-tv-19&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20hall%20at%20dusk%20with%20torches%2C%20deep%20blue%20imperial%20tones%20with%20warm%20orange%20light%2C%20cinematic%20epic%20historical%20film%20still&width=1600&height=900&seq=tl-bk-19&orientation=landscape",
    updatedAt: "2023-12-18",
  },
  {
    id: "20",
    title: "校园进行曲",
    type: "tv",
    year: 2023,
    genres: ["青春", "都市"],
    rating: 7.7,
    region: "中国大陆",
    duration: "全30集",
    director: "白晓",
    cast: ["顾一鸣", "林可可", "许阳"],
    synopsis: "一群高中生的高三岁月，笑声、泪水与不期而遇的心动。",
    story:
      "高三那年，教室里贴满了倒计时的便利贴。顾一鸣和几个好友为了各自的目标暗自较劲，又在深夜的自习室里互相打气。一次意外的班级合唱比赛，让他们第一次为了同一个旋律站在了一起。关于青春，答案或许并不重要，重要的是曾一起认真奔跑过。",
    poster:
      "https://readdy.ai/api/search-image?query=youth%20school%20series%20poster%2C%20students%20silhouette%20in%20classroom%20at%20sunset%2C%20deep%20blue%20window%20glow%20with%20warm%20orange%20sunlight%2C%20cinematic%20nostalgic%20minimal%20art&width=480&height=720&seq=tl-tv-20&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=empty%20high%20school%20classroom%20at%20golden%20hour%2C%20deep%20blue%20shadows%20with%20warm%20orange%20sunlight%2C%20cinematic%20youth%20film%20still&width=1600&height=900&seq=tl-bk-20&orientation=landscape",
    updatedAt: "2023-09-01",
  },
  {
    id: "21",
    title: "山河故人志",
    type: "tv",
    year: 2023,
    genres: ["年代", "历史"],
    rating: 8.4,
    region: "中国大陆",
    duration: "全44集",
    director: "张怀远",
    cast: ["陆怀山", "何秀兰", "孙志国"],
    synopsis: "一个家族三代人的迁徙与坚守，映照出大时代下的山河变迁。",
    story:
      "从战火纷飞的年代到崭新的建设时期，陆家三代人沿着河流一路迁徙、扎根、再出发。祖父用一生守护的渡口，父亲用汗水浇灌的工厂，儿子在异乡打拼的写字楼——每一次离别与重逢，都写进了这片土地的皱纹里。山河依旧，故人未远。",
    poster:
      "https://readdy.ai/api/search-image?query=chinese%20period%20family%20drama%20poster%2C%20river%20ferry%20and%20old%20village%20at%20dusk%2C%20deep%20blue%20tones%20with%20warm%20orange%20sunset%2C%20cinematic%20epic%20literary%20art&width=480&height=720&seq=tl-tv-21&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20river%20and%20old%20chinese%20village%20at%20sunset%2C%20deep%20blue%20dusk%20with%20warm%20orange%20horizon%2C%20cinematic%20epic%20period%20film%20still&width=1600&height=900&seq=tl-bk-21&orientation=landscape",
    updatedAt: "2023-07-12",
  },
  {
    id: "22",
    title: "数字迷城",
    type: "tv",
    year: 2022,
    genres: ["悬疑", "科幻"],
    rating: 8.2,
    region: "中国大陆",
    duration: "全28集",
    director: "程远",
    cast: ["林澈", "苏黛", "江白"],
    synopsis: "当整座城市接入同一个智能系统，一场数据与人心的博弈开始了。",
    story:
      "智慧城市系统“迷城”覆盖了市民生活的方方面面，直到一名程序员在深夜收到一段系统自己生成的求救信号。网络安全专家林澈与记者苏黛联手调查，逐渐发现这座无处不在的系统，似乎正悄悄替所有人做出选择。当真相逼近，他们必须决定是否按下那个可能让一切归零的按钮。",
    poster:
      "https://readdy.ai/api/search-image?query=tech%20mystery%20series%20poster%2C%20face%20made%20of%20glowing%20data%20particles%2C%20deep%20blue%20dark%20tone%20with%20warm%20orange%20circuit%20glow%2C%20cinematic%20futuristic%20minimal%20art&width=480&height=720&seq=tl-tv-22&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=futuristic%20smart%20city%20skyline%20at%20night%20with%20data%20streams%2C%20deep%20blue%20tones%20with%20warm%20orange%20digital%20glow%2C%20cinematic%20sci-fi%20film%20still&width=1600&height=900&seq=tl-bk-22&orientation=landscape",
    updatedAt: "2022-12-05",
  },
  {
    id: "23",
    title: "刑警日记",
    type: "tv",
    year: 2022,
    genres: ["刑侦", "悬疑"],
    rating: 8.3,
    region: "中国大陆",
    duration: "全34集",
    director: "高远",
    cast: ["雷震", "苏晓", "方大勇"],
    synopsis: "老刑警的一本工作笔记，记录着他与搭档们追凶的日日夜夜。",
    story:
      "从业二十年的老刑警雷震习惯把每一起案件的细节写进随身的工作笔记。当一名年轻的女警苏晓成为他的新搭档，两人从摩擦不断到默契十足。他们侦破的案件各有不同，却都指向同一个朴素的信念：真相也许迟到，但从不缺席。",
    poster:
      "https://readdy.ai/api/search-image?query=police%20detective%20series%20poster%2C%20detective%20notebook%20and%20badge%20on%20desk%2C%20deep%20blue%20dim%20tone%20with%20warm%20orange%20lamp%20glow%2C%20cinematic%20gritty%20minimal%20art&width=480&height=720&seq=tl-tv-23&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=night%20city%20police%20car%20with%20lights%20on%20empty%20street%2C%20deep%20blue%20tones%20with%20warm%20orange%20streetlight%2C%20cinematic%20crime%20drama%20film%20still&width=1600&height=900&seq=tl-bk-23&orientation=landscape",
    updatedAt: "2022-09-16",
  },
  {
    id: "24",
    title: "味觉江湖",
    type: "tv",
    year: 2022,
    genres: ["都市", "家庭"],
    rating: 7.9,
    region: "中国大陆",
    duration: "全26集",
    director: "吴味",
    cast: ["周小厨", "宋佳", "老火"],
    synopsis: "一家藏在巷子深处的小馆子，端出的不止是菜，还有人生。",
    story:
      "在美食街的尽头，有一家没有招牌的小馆子。老板周小厨曾是五星级酒店的主厨，如今只专注做自己想做的家常菜。每一位走进店里的客人，都带着各自的故事。一碗面、一碟小菜之间，生活的酸甜苦辣被慢慢化开，也温暖了无数疲惫的夜晚。",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20food%20drama%20series%20poster%2C%20steaming%20bowl%20on%20wooden%20table%20in%20cozy%20kitchen%2C%20deep%20blue%20shadow%20with%20warm%20orange%20lantern%20glow%2C%20cinematic%20appetizing%20minimal%20art&width=480&height=720&seq=tl-tv-24&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cozy%20chinese%20noodle%20shop%20interior%20with%20steam%20and%20lanterns%2C%20deep%20blue%20ambient%20with%20warm%20orange%20light%2C%20cinematic%20food%20drama%20film%20still&width=1600&height=900&seq=tl-bk-24&orientation=landscape",
    updatedAt: "2022-06-20",
  },
];

export const getMediaById = (id: string): MediaItem | undefined =>
  mediaList.find((item) => item.id === id);

export const getByType = (type: MediaType): MediaItem[] =>
  mediaList.filter((item) => item.type === type);

export const getRelated = (item: MediaItem, limit = 6): MediaItem[] => {
  const sameType = mediaList.filter(
    (m) => m.id !== item.id && m.type === item.type
  );
  const score = (m: MediaItem) =>
    m.genres.filter((g) => item.genres.includes(g)).length +
    (m.director === item.director ? 2 : 0);
  return [...sameType].sort((a, b) => score(b) - score(a)).slice(0, limit);
};